<template>
<b-container fluid class="top-padding bottom-padding no-horiz-padding">
    <div>
        <h2>Draft Color</h2>
        <p>Experiment with different warp and weft colors.</p>
    </div>

    <subscriber-login-prompt/>
    <div v-if='!isSubscriber' class='small-top-padding'></div>

    <div v-if='this.isAuthenticated && this.isSubscriber'>
        <div v-if='!draftLoaded'>
            <form name="fileSelectionForm">
                <label class='btn btn-primary' for="fileUpload">Choose a WIF to Upload</label>
                <input style='opacity:0' id='fileUpload' type="file" ref='kFileUpload' name="fileUpload" accept='.wif' @change="uploadFile"/>
            </form>
        </div>
        <div v-show='draftLoaded'>
            <div class='inline-auto-width small-top-padding small-right-padding'>
                <b-button @click='showWarpColorPicker' variant='default'>Warp Color »</b-button>
            </div>
            <div class='inline-auto-width small-top-padding small-right-padding'>
                <b-button @click='showWeftColorPicker' variant='default'>Weft Color »</b-button>
            </div>
            <div class='small-top-padding' v-if='warpColorPickerVisible'>
                <photoshop v-model='warpColor' @ok="warpColorChanged" @cancel="hideColorPickers" @change-color="warpColorChanged"/>
            </div>
            <div class='small-top-padding' v-if='replaceColorPickerVisible'>
                <photoshop v-model='replaceColor' @ok="replaceColorChanged" @cancel="hideColorPickers" @change-color="replaceColorChanged"/>
            </div>
            <div class='small-top-padding' v-if='weftColorPickerVisible'>
                <photoshop v-model='weftColor' @ok="weftColorChanged" @cancel="hideColorPickers" @change-color="weftColorChanged"/>
            </div>
            <div class='inline-auto-width small-top-padding'>
                <b-button @click='revert' variant='default'>Revert</b-button>
            </div>
            <div class='inline-auto-width small-top-padding'>
                <b-button @click='startOver' variant='default'>Start Over</b-button>
            </div>
            <div class='inline-auto-width small-top-padding'>
                <b-button @click='downloadColoredWIF' variant='default'>Download</b-button>
            </div>            
            <div class="inline-auto-width small-right-padding">
                View Size<br />
                <b-form-select class="form-control" v-model="viewsize" :options='viewsizeOptions'/>
            </div>
            <br/>
            <div class="inline-auto-width small-right-padding">
                <input v-model="includeDividingLines" type="checkbox" />&nbsp;Lines<br />
            </div>
            <div class="inline-auto-width small-right-padding">
                <input v-model="drawdownOnly" type="checkbox" />&nbsp;Drawdown Only<br />
            </div>
            <div class='small-top-padding small-right-padding'>
                (Or click the drawdown to search and replace color)
            </div>
        </div>

        <div class='top-padding' v-show='draftLoaded'>
            <img crossOrigin='Anonymous' ref='draftImageId' :src='currentDraftImageUrl' v-on:click='imageClick' />
        </div>
    </div>
    <b-modal auto-focus-button='ok' ref='replaceModalRef' title='Choose Color Replacement' :ok-only='true' ok-title='Cancel' ok-variant='secondary' :no-close-on-backdrop='true' :no-close-on-esc='true' @ok='showReplaceDialog(false)'>
        <div class="d-block text-center">
            Replace color in warp, weft, or both?
            <br/>
            <br/>
            <b-button style='small-right-padding' @click='replaceColorWIFAndShowImage(true, false)' variant='primary'>Replace in Warp »</b-button>
            <b-button style='small-left-padding' @click='replaceColorWIFAndShowImage(false, true)' variant='primary'>Replace in Weft »</b-button>
            <b-button style='small-left-padding' @click='replaceColorWIFAndShowImage(true, true)' variant='primary'>Replace in Both »</b-button>
        </div>
    </b-modal>

</b-container>

</template>

<script>
import loginControl from './LoginControl.vue'
import dataService from '../mixins/dataService.js'
import urlsService from '../mixins/urlsService.js'
import mediaService from '../mixins/mediaService.js'
import subscriberLoginPrompt from './SubscriberLoginPrompt.vue'
import { Photoshop } from 'vue-color'

let determineOptimalDraftDisplaySizeFunction

export default {
    mixins: [dataService, urlsService, mediaService],
    components: {
        loginControl: loginControl,
        subscriberLoginPrompt: subscriberLoginPrompt,
        photoshop: Photoshop
    },
    data: function() {
        return {
            draftLoaded: false,
            filename: '',
            warpColor: {
                'hex': '#000000'
            },
            weftColor: {
                'hex': '#FFFFFF'
            },
            replaceColor: {
                'hex': '#000000'
            },
            // warpColorHex: '#000000',
            // weftColorHex: '#FFFFFF',
            searchColorHex: '',
            // replaceColorHex: '#000000',
            warpColorPickerVisible: false,
            weftColorPickerVisible: false,
            replaceColorPickerVisible: false,
            wifText: '',
            originalWIFText: '',
            uploadedWIFText: '',
            originalWarpColor: null,
            originalWeftColor: null,
            drawdownOnly: false,
            includeDividingLines: true,
            viewsize: 4,
            viewsizeOptions: [
                { value: 2, text: 'smallest' },
                { value: 3, text: 'smaller' },
                { value: 4, text: 'small' },
                { value: 5, text: 'medium' },
                { value: 7, text: 'large' },
                { value: 9, text: 'larger' },
                { value: 11, text: 'largest' }
            ],
            windowWidth: 0,
            windowHeight: 0,
            warpThreadsCount: 1,
            weftThreadsCount: 1,
            treadlesCount: 1,
            shaftsCount: 1
        }
    },
    methods: {
        uploadFile(evt) {
            let file = document.getElementById('fileUpload').files[0]
            let boundThis = this
            // if user hits escape key on login dialog, can still get here without login, make them log in instead of uploading by reloading if that happens
            if (boundThis.isAuthenticated) {
                let fileReader = new FileReader()
                fileReader.onload = function(e) {
                    let wifText = e.target.result
                    boundThis.wifText = wifText
                    boundThis.originalWIFText = wifText
                    boundThis.uploadWIFAndShowImage()
                    if (!boundThis.originalWarpColor) {
                        boundThis.originalWarpColor = boundThis.warpColor
                    }
                    if (!boundThis.originalWeftColor) {
                        boundThis.originalWeftColor = boundThis.weftColor
                    }
                }
                fileReader.readAsText(file)
                this.draftLoaded = true
            }

            determineOptimalDraftDisplaySizeFunction = this.determineOptimalDraftDisplaySize.bind(this)
            window.addEventListener('resize', determineOptimalDraftDisplaySizeFunction)
        },
        warpColorChanged() {
            this.colorWIFAndShowImage(true)
            this.hideColorPickers()
        },
        weftColorChanged() {
            this.colorWIFAndShowImage(false)
            this.hideColorPickers()
        },
        replaceColorChanged() {
            this.hideColorPickers()
            this.showReplaceDialog(true)
        },
        hideColorPickers() {
            this.warpColorPickerVisible = false
            this.weftColorPickerVisible = false
            this.replaceColorPickerVisible = false
        },
        showWarpColorPicker() {
            this.warpColorPickerVisible = true
        },
        showWeftColorPicker() {
            this.weftColorPickerVisible = true
        },
        showReplaceColorPicker() {
            this.replaceColorPickerVisible = true
        },
        showReplaceDialog: function(isShow) {
            isShow ? this.$refs.replaceModalRef.show() : this.$refs.replaceModalRef.hide()
        },
        revert() {
            this.wifText = this.originalWIFText
            this.warpColor = this.originalWarpColor
            this.weftColor = this.originalWeftColor
            this.uploadWIFAndShowImage()
        },
        startOver() {
            this.wifText = ''
            this.originalWIFText = ''
            this.draftLoaded = false
            // this.warpColorHex = null
            // this.weftColorHex = null
        },
        uploadWIFAndShowImage() {
            this.postPattern(this.wifText, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                if (resp.status === 200 && resp.data.length > 0) {
                    // console.log('respData: ' + resp.data)
                    let colorObj = JSON.parse(resp.data)
                    this.warpColor.hex = colorObj.warpColor
                    // this.warpColorHex = colorObj.warpColor
                    // this.weftColor.hex = colorObj.weftColor
                    // this.weftColorHex = colorObj.weftColor
                    // this.replaceColorHex = this.replaceColor.hex
                    this.warpThreadsCount = colorObj.warpThreadsCount
                    this.weftThreadsCount = colorObj.weftThreadsCount
                    this.treadlesCount = colorObj.treadlesCount
                    this.shaftsCount = colorObj.shaftsCount
                    // console.log('this.warpThreadCount: ' + this.warpThreadsCount + ', this.weftThreadsCount: ' + this.weftThreadsCount + ', treadlesCount: ' + this.treadlesCount + ', shaftsCount: ' + this.shaftsCount)
                    // console.log('type of this.determineOptimalDraftDisplaySize: ' + typeof this.determineOptimalDraftDisplaySize)
                    this.determineOptimalDraftDisplaySize()
                    // console.log('after determineOptimalDraftDisplaySize')
                    this.uploadedWIFText = this.wifText
                }
            })
        },
        colorWIFAndShowImage(isWarp) {
            let warpColorRGB = this.rgbColorString(true)
            let weftColorRGB = this.rgbColorString(false)

            this.colorPattern(this.wifText, this.authUser.UserID, this.authUser.LoginToken, warpColorRGB, weftColorRGB, isWarp ? 'true' : 'false').then(resp => {
                if (resp.status === 200 && resp.data.length > 0) {
                    this.wifText = resp.data
                    this.uploadWIFAndShowImage()
                }
            })
        },
        replaceColorWIFAndShowImage(replaceWarp, replaceWeft) {
            this.showReplaceDialog(false)
            let searchColorHexStr = this.searchColorHex.substring(1)
            let replaceColorHexStr = this.replaceColor.hex.substring(1)

            this.colorPatternReplace(this.wifText, this.authUser.UserID, this.authUser.LoginToken, searchColorHexStr, replaceColorHexStr, replaceWarp, replaceWeft).then(resp => {
                if (resp.status === 200 && resp.data.length > 0) {
                    this.wifText = resp.data
                    // alert(this.wifText)
                    // // console.log(this.wifText)
                    this.uploadWIFAndShowImage()
                }
            })
        },
        rgbColorString(isWarp) {
            let rgbStr = isWarp ? this.warpColor.hex.substring(1) : this.weftColor.hex.substring(1)
            return rgbStr
        },
        determineOptimalDraftDisplaySize() {
            // work around Webkit bug where mobile scrolling sometimes triggers resize event even though window is not resizing
            if (window.innerWidth !== this.windowWidth) {
                let draftObj = { WarpThreads: this.warpThreadsCount, WeftThreads: this.weftThreadsCount, Treadles: this.treadlesCount, Shafts: this.shaftsCount }

                // console.log('in determineOptimalDraftDisplaySize, draftObj: ' + JSON.stringify(draftObj))

                this.viewsize = this.calculateDraftInitialDisplaySize(draftObj, window.innerWidth, false)
                this.windowWidth = window.innerWidth
                this.windowHeight = window.innerHeight
                // console.log('in determineOptimalDraftDisplaySize, draftObj: ' + JSON.stringify(draftObj) + ', viewsize: ' + this.viewsize + ', windowWidth: ' + this.windowWidth + ', windowHeight: ' + this.windowHeight)
            }
        },
        downloadColoredWIF() {
            let wifDownloadUrl = this.getTempWIFDownloadUrl(this.authUser.UserID, this.authUser.LoginToken)
            window.location.assign(wifDownloadUrl)
        },
        imageClick(event) {
            let img = this.$refs['draftImageId']
            // alert('Image clicked at: ' + event.clientX + ', ' + event.clientY)

            var canvas = document.createElement('canvas')
            canvas.width = img.width
            canvas.height = img.height
            canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height)

            // After that, when a user clicks, use event.offsetX and event.offsetY to get the position. This can then be used to acquire the pixel:

            var pixelData = canvas.getContext('2d').getImageData(event.offsetX, event.offsetY, 1, 1).data
            let r = parseInt(pixelData[0])
            let g = parseInt(pixelData[1])
            let b = parseInt(pixelData[2])

            let rHex = r.toString(16)
            if (rHex.length < 2) {
                rHex = '0' + rHex
            }

            let gHex = g.toString(16)
            if (gHex.length < 2) {
                gHex = '0' + gHex
            }

            let bHex = b.toString(16)
            if (bHex.length < 2) {
                bHex = '0' + bHex
            }

            let hexColorStr = '#' + rHex + gHex + bHex
            this.searchColorHex = hexColorStr

            // alert('r: ' + r + ', g: ' + g + ', b: ' + b + ', hex: ' + this.searchColorHex)
            // this.replaceColorHex = this.searchColorHex

            this.replaceColor = { 'hex': hexColorStr }

            this.$nextTick(function() {
                // console.log('this.replaceColor ' + JSON.stringify(this.replaceColor))
                this.showReplaceColorPicker()
            })
        }
    },
    computed: {
        isSubscriber: function() {
            return this.$store.getters.isSubscriber
        },
        isAuthenticated: function() {
            return this.$store.getters.isAuthenticated
        },
        authUser: function() {
            return this.$store.state.authUser
        },
        currentDraftImageUrl: function() {
            // note: extra params at the end of this method call are so the reactivity system will pick up changes and redraw, they aren't actually used otherwise by the method
            let newImageUrl = this.getTempDraftImageUrl(this.authUser.UserID, this.viewsize, this.authUser.LoginToken, this.drawdownOnly, this.includeDividingLines, this.wifText, this.uploadedWIFText) //, this.warpColorHex, this.weftColorHex, this.replaceColorHex, this.wiftext)
            // console.log('in currentDraftImageUrl, newImageUrl: ' + newImageUrl)
            if (this.draftLoaded) {
                return newImageUrl
            }
            else return '#'
        }
    },
    destroyed() {
        window.removeEventListener('resize', determineOptimalDraftDisplaySizeFunction)
    }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/DraftColor.vue